/**
 * @package Ninja Forms builder
 * @subpackage Merge Tag Box
 * @copyright (c) 2017 WP Ninjas
 * @since 3.1
 */

define( 'controllers/app/mergeTagBox',[
    'models/app/mergeTagModel',
    'models/app/mergeTagLookupCollection',
    'views/app/drawer/mergeTag',
    'views/app/drawer/mergeTagList',
    'views/app/drawer/mergeTagGroup',
    'views/app/drawer/mergeTagGroupList',
    'views/app/drawer/mergeTagFilter',
    'views/app/drawer/mergeTagBox'
], function(
    MergeTagModel,
    MergeTagLookupCollection,
    MergeTagView,
    MergeTagListView,
    MergeTagGroupView,
    MergeTagGroupListView,
    MergeTagFilterView,
    MergeTagBoxLayout
) {
    var controller = Marionette.Object.extend( {

        caret: 0, // Track the caret position of the current setting's input.
        old: '', // THe old merge tag that will be replaced.

        initialize: function(){

            this.listenTo( nfRadio.channel( 'drawer' ), 'render:settingGroup', function(){
                jQuery( '.merge-tags' ).off( 'click' );
                jQuery( '.merge-tags' ).on( 'click', this.mergeTagsButtonClick );
            });

            this.listenTo( nfRadio.channel( 'app' ), 'after:appStart', this.afterAppStart );
            this.listenTo( nfRadio.channel( 'app' ), 'before:renderSetting', this.beforeRenderSetting );
            this.listenTo( nfRadio.channel( 'drawer' ), 'before:close', this.beforeDrawerClose );

            var that = this;
            nfRadio.channel( 'mergeTags' ).reply( 'set:caret', function( position ){
               that.caret = position;
            });
            nfRadio.channel( 'mergeTags' ).reply( 'get:caret', function(){
                return that.caret;
            });

            var that = this;
            nfRadio.channel( 'mergeTags' ).reply( 'set:old', function( value ){
                that.old = value;
            });
            nfRadio.channel( 'mergeTags' ).reply( 'get:old', function(){
                return that.old;
            });

            nfRadio.channel( 'mergeTags' ).reply( 'insert:tag', this.insertTag.bind( this ) );

            /** OPTION REPEATER */
            this.listenTo( nfRadio.channel( 'option-repeater' ), 'add:option', function( model ){
                var selector = '#' + model.cid + ' .has-merge-tags input.setting';
                jQuery( selector ).on( 'focus', function( event ){
                   that.focusCallback( event, selector, 'option-repeater' );
                });
                jQuery( selector ).on( 'keyup', function( event ){
                    that.keyupCallback( event, selector, 'option-repeater' );
                });
                jQuery( selector ).siblings( '.nf-list-options .merge-tags' ).off( 'click' );
                jQuery( selector ).siblings( '.nf-list-options .merge-tags' ).on( 'click', this.mergeTagsButtonClick );
            } );
            this.listenTo( nfRadio.channel( 'drawer' ), 'opened', function(){
                jQuery( '.nf-list-options .merge-tags' ).off( 'click' );
                jQuery( '.nf-list-options .merge-tags' ).on( 'click', this.mergeTagsButtonClick );
            } );

            /* CALCULATIONS */
            this.listenTo( nfRadio.channel( 'setting-calculations-option' ), 'render:setting', this.renderSetting );
            // this.listenTo( nfRadio.channel( 'setting-calculations-option' ), 'render:setting', function( settingModel, dataModel, view ){
            //     view.$el.find( '.merge-tags' ).on( 'click', this.mergeTagsButtonClick );
            // } );
            this.listenTo( nfRadio.channel( 'drawer' ), 'opened', function(){
                jQuery( '.nf-list-options.calculations .merge-tags' ).off( 'click' );
                jQuery( '.nf-list-options.calculations .merge-tags' ).on( 'click', this.mergeTagsButtonClick );
            } );

            /* QUILL */
            this.listenTo( nfRadio.channel( 'quill' ), 'focus', function( settingModel, dataModel, quill ) {
                that.quillInstance = quill;
                that.focusCallback( false, quill.root, 'rte' );
            } );
            this.listenTo( nfRadio.channel( 'quill' ), 'change', function( settingModel, dataModel, value ){
                // Save current selection for merge tag insertion
                if( that.quillInstance ) {
                    that.quillSelection = that.quillInstance.getSelection();
                }
            } );

            // When an RTE setting is shown, make sure merge tags are hooked up.
            this.listenTo( nfRadio.channel( 'setting-type-rte' ), 'render:setting', function(){
                jQuery( '.ql-toolbar .merge-tags, .ql-nf-merge-tags' ).off( 'click' );
                jQuery( '.ql-toolbar .merge-tags, .ql-nf-merge-tags' ).on( 'click', this.mergeTagsButtonClick );
            } );

            this.listenTo( nfRadio.channel( 'drawer' ), 'opened', function(){
                jQuery( '.ql-toolbar .merge-tags, .ql-nf-merge-tags' ).off( 'click' );
                jQuery( '.ql-toolbar .merge-tags, .ql-nf-merge-tags' ).on( 'click', this.mergeTagsButtonClick );
            } );

            jQuery( document ).on( 'keyup', function( event ){
                if( 27 == event.keyCode ){
                    // Only act when the merge tag box is actually visible — otherwise
                    // ESC would use stale 'old' state to delete content from Quill (#7884)
                    if ( 'none' === jQuery( '#merge-tags-box' ).css( 'display' ) ) return;
                    nfRadio.channel( 'mergeTags' ).request( 'insert:tag', '' );
                    jQuery( '#merge-tags-box' ).css( 'display', 'none' );
                    nfRadio.channel( 'drawer' ).request( 'enable:close' );
                    jQuery( '#merge-tags-box' ).removeClass();
                    jQuery( '.merge-tag-focus' ).blur();
                    jQuery( '.merge-tag-focus' ).removeClass( 'merge-tag-focus' );
                    jQuery( '.merge-tag-focus-overlay' ).removeClass( 'merge-tag-focus-overlay' );
                }
            });

            /**
             * Listen to the Field Changes (add, delete, update) and update the Merge Tags.
             */
            this.listenTo( Backbone.Radio.channel( 'fields' ), 'add:field',    this.afterAppStart );
            this.listenTo( Backbone.Radio.channel( 'fields' ), 'delete:field', this.afterAppStart );
            this.listenTo( Backbone.Radio.channel( 'fieldSetting-key' ), 'update:setting', this.afterAppStart );
            this.listenTo( Backbone.Radio.channel( 'fieldSetting-label' ), 'update:setting', this.afterAppStart );

            /** ... and Calc updates. */
            this.listenTo( Backbone.Radio.channel( 'calcs' ), 'update:calc', this.afterAppStart );

            this.listenTo( Backbone.Radio.channel( 'app' ), 'change:currentDomain', this.afterAppStart );
        },

        afterAppStart: function() {

            var currentDomain = Backbone.Radio.channel( 'app' ).request( 'get:currentDomain' );

            var mergeTagCollection = nfRadio.channel( 'mergeTags' ).request( 'get:collection' );
            var mergeTags = [];
            mergeTagCollection.each( function( section ){

                section.get( 'tags' ).each( function( tag ){

                    if( 'fields' == currentDomain.get( 'id' ) && '{submission:sequence}' == tag.get( 'tag' ) ) return;

                    mergeTags.push({
                        label: tag.get( 'label' ),
                        tag:   tag.get( 'tag' ),
                        section: section.get( 'id' )
                    });
                });
            });
            var layout = new MergeTagBoxLayout();
            layout.render();
            var tagCollection = new MergeTagLookupCollection( mergeTags );
            var mergeTagListView = new MergeTagListView({
                collection: tagCollection
            });
            var mergeTagGroupListView = new MergeTagGroupListView({
                collection: mergeTagCollection
            });

            layout.getRegion('tags').show(mergeTagListView);
            layout.getRegion('sections').show(mergeTagGroupListView);
            layout.getRegion('filter').show(new MergeTagFilterView);
        },

        beforeRenderSetting: function( settingModel, dataModel ){
            if( 'undefined' == typeof settingModel.get( 'use_merge_tags' ) ) return;
            if( ! settingModel.get( 'use_merge_tags' ) ) return;
            var name = settingModel.get( 'name' );
            this.listenTo( nfRadio.channel( 'setting-' + name ), 'render:setting', this.renderSetting );
        },

        renderSetting: function( settingModel, dataModel, view ){

            view.$el.find( '.merge-tags' ).off( 'click' );
            view.$el.find( '.merge-tags' ).on( 'click', this.mergeTagsButtonClick );

            if( 0 == jQuery( '#merge-tags-box' ).length ) this.afterAppStart();

            // Track Scrolling.
            jQuery( '#nf-drawer' ).on( 'scroll', function(){
               // COPIED AND MODIFIED FROM FOCUS
                if( 0 == jQuery( '.merge-tag-focus' ).length ) return;

                var rteEditor = jQuery( '.merge-tag-focus' ).closest( '.nf-setting' ).find( '.ql-container' );
                if( 0 != rteEditor.length ){
                    var posY = rteEditor.offset().top - jQuery(window).scrollTop();
                    var height = rteEditor.outerHeight();
                } else {
                    var posY = jQuery('.merge-tag-focus').offset().top - jQuery(window).scrollTop();
                    var height = jQuery('.merge-tag-focus').outerHeight();
                }

	            // Find out if merge tag box will go below bottom of the page.
	            var tagBoxY = posY + height;
	            var windowHeight = window.innerHeight;
	            var tagBoxHeight = jQuery( '#merge-tags-box' ).outerHeight();

	            // If merge tag box will render below the bottom of the page,
	            // change it to render above the field

	            if ( ( tagBoxY + tagBoxHeight ) > windowHeight ) {
                    tagBoxY = posY - tagBoxHeight;
                }

                if ( 0 > tagBoxY ) {
                    tagBoxY = posY;
                }

                jQuery( '#merge-tags-box' ).css( 'top', tagBoxY );

                var boxHeight = jQuery( '#merge-tags-box' ).outerHeight();
                jQuery( '#nf-drawer' ).css( 'padding-bottom', boxHeight + 'px' );

                var repeaterRow = jQuery( '.merge-tag-focus' ).closest( '.nf-list-options-tbody' );
                if( 0 != repeaterRow.length ){
                    var left = repeaterRow.offset().left - jQuery(window).scrollLeft();
                    jQuery( '#merge-tags-box' ).css( 'left', left );
                } else {
                    var posX = jQuery( '.merge-tag-focus' ).closest( '.nf-settings' ).offset().left - jQuery(window).scrollLeft();
                    jQuery( '#merge-tags-box' ).css( 'left', posX );
                    jQuery( '#merge-tags-box' ).css( 'width', jQuery( '.merge-tag-focus' ).closest( '.nf-settings' ).width() );
                }
            });

            // On input focus, move the Merge Tag Box into position.
            jQuery( view.el ).find( '.setting' ).on( 'focus', this.focusCallback );

            // TODO: Maybe move to view events.
            // On input keyup, maybe show Merge Tag Box.
            jQuery( view.el ).find( '.setting' ).on( 'keyup', this.keyupCallback );
        },

        // TODO: Maybe move to view class.
        beforeDrawerClose: function(){
            jQuery( '#merge-tags-box' ).css( 'display', 'none' );
            nfRadio.channel( 'drawer' ).request( 'enable:close' );
            // Clear merge-tag state so a subsequent ESC press in another
            // context can't use stale caret/old values to delete content (#7884).
            this.caret = 0;
            this.old = '';
            window.nfCurrentQuillInstance = null;
            window.nfCurrentCodeMirror = null;
            // jQuery( 'body' ).append( jQuery( '#merge-tags-box' ) );
        },

        insertTag: function( tag ) {
            // Check if we're in code view with a CodeMirror instance
            if( window.nfCurrentCodeMirror ) {
                var cm = window.nfCurrentCodeMirror;
                var find = nfRadio.channel( 'mergeTags' ).request( 'get:old' );
                var replace = tag;
                var caretPos = nfRadio.channel( 'mergeTags' ).request( 'get:caret' );

                // Replace the partial merge tag text with the full tag
                var replaceStart = cm.posFromIndex(caretPos - find.length);
                var replaceEnd = cm.posFromIndex(caretPos);
                cm.replaceRange(replace, replaceStart, replaceEnd);

                // Set cursor after inserted tag
                var newCursorIndex = caretPos - find.length + replace.length;
                cm.setCursor(cm.posFromIndex(newCursorIndex));
                cm.focus();

                // Clean up
                jQuery( '#merge-tags-box' ).css( 'display', 'none' );
                nfRadio.channel( 'drawer' ).request( 'enable:close' );
                window.nfCurrentCodeMirror = null;

                return;
            }

            // Check if we have a global Quill instance first (for Quill RTEs)
            if( window.nfCurrentQuillInstance ) {
                var quillInstance = window.nfCurrentQuillInstance;
                var find = nfRadio.channel( 'mergeTags' ).request( 'get:old' );
                var replace = tag;
                var caretPos = nfRadio.channel( 'mergeTags' ).request( 'get:caret' );

                // The caret position is right after the { character
                // So the { is at position caretPos - 1
                var replaceIndex = caretPos - 1;
                var replaceLength = find.length;

                // Guard against destructive deletes from stale state (#7884).
                // If `find` is empty/missing, or the caret position is invalid,
                // or the text at replaceIndex doesn't actually match `find`,
                // refuse to delete and just close the box. Without these checks
                // an ESC press with leftover state would chew through real
                // content one character at a time.
                var quillText = quillInstance.getText();
                var stateIsValid = (
                    typeof find === 'string' && find.length > 0 &&
                    replaceIndex >= 0 &&
                    replaceIndex + replaceLength <= quillText.length &&
                    quillText.substr( replaceIndex, replaceLength ) === find
                );

                if ( ! stateIsValid ) {
                    // Just close the box and clean up — do NOT mutate content.
                    jQuery( '.merge-tag-focus-overlay' ).removeClass( 'merge-tag-focus-overlay' );
                    jQuery( '.merge-tag-focus' ).removeClass( 'merge-tag-focus' );
                    jQuery( '#merge-tags-box' ).css( 'display', 'none' );
                    nfRadio.channel( 'drawer' ).request( 'enable:close' );
                    window.nfCurrentQuillInstance = null;
                    return;
                }

                quillInstance.deleteText(replaceIndex, replaceLength);
                quillInstance.insertText(replaceIndex, replace);

                // Set cursor position after the inserted tag
                var cursorPos = replaceIndex + replace.length;
                quillInstance.setSelection(cursorPos);

                // Clean up
                jQuery( '.merge-tag-focus-overlay' ).removeClass( 'merge-tag-focus-overlay' );
                jQuery( '.merge-tag-focus' ).removeClass( 'merge-tag-focus' );
                jQuery( '#merge-tags-box' ).css( 'display', 'none' );
                nfRadio.channel( 'drawer' ).request( 'enable:close' );

                // Clear the global instance
                window.nfCurrentQuillInstance = null;

                return;
            }

            // Otherwise, use the original logic for regular inputs
            var $input = jQuery( '.merge-tag-focus' );

            if( 0 != $input.closest( '.nf-setting' ).first().find( '.ql-editor' ).length ){
                $input = $input.closest( '.nf-setting' ).first().find( '.ql-editor' );
            }

            if( 1 < $input.length ){ $input = $input.first(); }

            if( $input.hasClass( 'ql-editor' ) ){
                var str = $input.html();
            } else {
                var str = $input.val();
            }

            var find = nfRadio.channel( 'mergeTags' ).request( 'get:old' );
            var replace = tag;
            var caretPos = nfRadio.channel( 'mergeTags' ).request( 'get:caret' );

            var patt = /{([a-zA-Z0-9]|:|_||-|}| |\/)*/g;

            // Loop through matches to find insert/replace index range.
            // Reference: http://codepen.io/kjohnson/pen/36c3a782644dfff40fe3c1f05f8739d9?editors=0012
            while (match = patt.exec(str)) {
                if (find != match[0]) continue; // This isn't the match you are looking for...
                var string = str.slice(0, match.index) + replace + str.slice(patt.lastIndex); // Fancy replace for the specifc match, using the index/position.

                $input.val(string); // Update input value with parsed string.
                $input.change(); // Trigger a change event after inserting the merge tag so that it saves to the model.
                $input.caret(caretPos - find.length + replace.length); // Update Carept Position.

            }

            jQuery( '#merge-tags-box' ).css( 'display', 'none' );
            nfRadio.channel( 'drawer' ).request( 'enable:close' );
            $input.removeClass( 'merge-tag-focus' );
            $input.closest( '.merge-tag-focus-overlay' ).removeClass( 'merge-tag-focus-overlay' );
        },

        mergeTagsButtonClick: function( e ){
            var $this = jQuery( this );

            if ($this.hasClass('open-media-manager')) {
                return;
            }

            if( $this.siblings().hasClass( 'merge-tag-focus' ) ){
                nfRadio.channel( 'mergeTags' ).request( 'insert:tag', '' );
                jQuery( '#merge-tags-box' ).css( 'display', 'none' );
                nfRadio.channel( 'drawer' ).request( 'enable:close' );
                jQuery( '.merge-tag-focus' ).removeClass( 'merge-tag-focus' );
                jQuery( '.merge-tag-focus-overlay' ).removeClass( 'merge-tag-focus-overlay' );
                return;
            }

            // Check if this is a button inside a Quill toolbar
            var $toolbar = $this.closest('.ql-toolbar');
            if ( $toolbar.length > 0 ) {
                // This is a Quill toolbar button - find the Quill container
                var $settingContainer = $toolbar.closest('.nf-setting');
                var $quillContainer = $settingContainer.find('.ql-container');
                var $settingEl = $settingContainer.find('.setting');

                // Get Quill instance
                var quillInstance = window.nfCurrentQuillInstance;
                if ( !quillInstance ) {
                    quillInstance = $settingEl.data('quill');
                }
                if ( !quillInstance ) {
                    var quillEl = $quillContainer.find('.ql-editor');
                    if ( quillEl.length && quillEl[0].__quill ) {
                        quillInstance = quillEl[0].__quill;
                    }
                }

                if ( quillInstance ) {
                    // Store globally for merge tag insertion
                    window.nfCurrentQuillInstance = quillInstance;

                    // Get current selection or insert at end of content
                    var range = quillInstance.getSelection();
                    var insertIndex;
                    if (range) {
                        insertIndex = range.index;
                    } else {
                        // No selection, insert at end
                        insertIndex = Math.max(0, quillInstance.getLength() - 1);
                    }

                    // Insert { character
                    quillInstance.insertText(insertIndex, '{');
                    quillInstance.setSelection(insertIndex + 1);

                    // Set merge tag system variables
                    nfRadio.channel('mergeTags').request('set:caret', insertIndex + 1);
                    nfRadio.channel('mergeTags').request('set:old', '{');

                    // Mark editor as focused
                    jQuery(quillInstance.root).addClass('merge-tag-focus');

                    // Add overlay class
                    $settingContainer.find('.ql-container').parent().addClass('merge-tag-focus-overlay');

                    // Update tag list and show merge tags box
                    nfRadio.channel('merge-tags').request('update:taglist', 'fields', false);
                    jQuery('#merge-tags-box').css('display', 'block');
                    nfRadio.channel('drawer').request('prevent:close');

                    // Position the merge tag box
                    nfRadio.channel('mergeTags').trigger('focus', quillInstance.root, 'rte');

                    // Focus the search input
                    setTimeout(function() {
                        jQuery('#merge-tags-box').find('.merge-tag-filter').find('input').focus();
                    }, 100);

                    return;
                }
            }

            // Standard merge tag button (not in Quill toolbar)
            var $inputSetting = $this.siblings( '.setting' ).first();

            // Check if this is a Quill RTE editor (standard button next to RTE)
            var $quillContainer = $inputSetting.find( '.ql-container' );
            if ( $quillContainer.length > 0 ) {
                // Handle Quill editor with standard button
                var quillInstance = window.nfCurrentQuillInstance;
                if ( !quillInstance ) {
                    quillInstance = $inputSetting.data( 'quill' );
                }
                if ( !quillInstance ) {
                    var quillEl = $quillContainer.find( '.ql-editor' );
                    if ( quillEl.length && quillEl[0].__quill ) {
                        quillInstance = quillEl[0].__quill;
                    }
                }

                if ( quillInstance ) {
                    window.nfCurrentQuillInstance = quillInstance;

                    var range = quillInstance.getSelection();
                    var insertIndex = range ? range.index : Math.max(0, quillInstance.getLength() - 1);

                    quillInstance.insertText(insertIndex, '{');
                    quillInstance.setSelection(insertIndex + 1);

                    nfRadio.channel('mergeTags').request('set:caret', insertIndex + 1);
                    nfRadio.channel('mergeTags').request('set:old', '{');

                    jQuery(quillInstance.root).addClass('merge-tag-focus');
                } else {
                    return;
                }
            } else {
                // Handle regular input/textarea
                var text = $inputSetting.val() || '';
                $inputSetting.val( text + '{' ).change();
                nfRadio.channel('mergeTags').request('set:caret', text.length + 1 );
                nfRadio.channel('mergeTags').request('set:old', '{' );
                $inputSetting.addClass( 'merge-tag-focus' );
            }

            // Disable browser autocomplete.
            var autocomplete = $this.attr( 'autocomplete' );
            $this.attr( 'autocomplete', 'off' );
            $this.data( 'autocomplete', autocomplete );

            var $overlayElement = $this.closest( '.nf-setting, .nf-table-row' );
            if( 0 != $overlayElement.find( '.ql-container' ).length ){
                $overlayElement.find('.ql-container' ).parent().addClass('merge-tag-focus-overlay');
            } else {
                $overlayElement.addClass('merge-tag-focus-overlay');
            }

            /**
             * TODO: This is a wonky work around for removing Product and Quantity fields from calculation merge tags.
             * The merge tag system doesn't currently respect "exclude" merge tag settings.
             *
             * If 'eq' is the textarea next to the merge tag icon, then we're in a calculation setting.
             */
            if ( 'eq' == jQuery( e.target ).prev( 'textarea' ).data( 'id' ) ) {
                var calc = true;
            } else {
                var calc = false;
            }

            // Request that our merge tag box update its tag list, passing whether or not we're in a calculation setting.
            nfRadio.channel( 'merge-tags' ).request( 'update:taglist', 'fields', calc );
            
            jQuery( '#merge-tags-box' ).css( 'display', 'block' );
            nfRadio.channel( 'drawer' ).request( 'prevent:close' );

            jQuery( '.merge-tag-focus-overlay' ).off( 'click' );
            jQuery( '.merge-tag-focus-overlay' ).on( 'click', function( e ) {
                if ( jQuery( e.target ).hasClass( 'ql-editor' ) || jQuery( e.target ).closest( '.ql-container' ).length ) {
                    nfRadio.channel( 'mergeTags' ).request( 'insert:tag', '' );
                    jQuery( '#merge-tags-box' ).css( 'display', 'none' );
                    nfRadio.channel( 'drawer' ).request( 'enable:close' );
                    jQuery( '#merge-tags-box' ).removeClass();
                    jQuery( '.merge-tag-focus' ).removeClass( 'merge-tag-focus' );
                    jQuery( '.merge-tag-focus-overlay' ).removeClass( 'merge-tag-focus-overlay' );
                }
            } );

            setTimeout(function(){
                jQuery( '#merge-tags-box' ).find( '.merge-tag-filter' ).find( 'input' ).focus();
            }, 500 );
        },

        focusCallback: function( e, target, type ){

            var type = type || 'setting';
            var $this = ( 'undefined' == typeof target ) ? jQuery( this ) : jQuery( target );

            jQuery( '.merge-tag-focus' ).each(function(index, el){
                if( this == el ) return;
                el.removeClass( 'merge-tag-focus' );
            });

            if( 'rte' == type ) {
                var rteContainer = $this.closest( '.nf-setting' ).find( '.ql-container' );
                if( rteContainer.length && rteContainer.offset() ) {
                    var posY = rteContainer.offset().top - jQuery(window).scrollTop();
                    var height = rteContainer.outerHeight();
                } else {
                    // Fallback if no RTE container found
                    var posY = $this.offset().top - jQuery(window).scrollTop();
                    var height = $this.outerHeight();
                }
            } else {
                var posY = $this.offset().top - jQuery(window).scrollTop();
                var height = $this.outerHeight();
            }

            // Find out if merge tag box will go below bottom of the page.
	        var tagBoxY = posY + height;
	        var windowHeight = window.innerHeight;
	        var tagBoxHeight = jQuery( '#merge-tags-box' ).outerHeight();

	        // If merge tag box will render below the bottom of the page,
            // change it to render above the field

	        if ( ( tagBoxY + tagBoxHeight ) > windowHeight ) {
		        tagBoxY = posY - tagBoxHeight;
	        }

            if ( 0 > tagBoxY ) {
                tagBoxY = posY;
            }

            jQuery( '#merge-tags-box' ).css( 'top', tagBoxY );

            var repeaterRow = $this.closest( '.nf-list-options-tbody' );
            if( 0 != repeaterRow.length ) {
                var left = repeaterRow.offset().left - jQuery(window).scrollLeft();
                jQuery( '#merge-tags-box' ).css( 'left', left );
            } else if( 'rte' == type ) {
                var rteContainer = $this.closest( '.nf-setting' ).find( '.ql-container' );
                if( rteContainer.length && rteContainer.offset() ) {
                    var posX = rteContainer.offset().left - jQuery(window).scrollLeft();
                    jQuery( '#merge-tags-box' ).css( 'left', posX );
                    jQuery( '#merge-tags-box' ).css( 'width', rteContainer.width() );
                } else {
                    // Fallback to settings container
                    var posX = jQuery( this ).closest( '.nf-settings' ).offset().left - jQuery(window).scrollLeft();
                    jQuery( '#merge-tags-box' ).css( 'left', posX );
                    jQuery( '#merge-tags-box' ).css( 'width', $this.closest( '.nf-settings' ).width() );
                }
            }
            else
            {
                var posX = jQuery( this ).closest( '.nf-settings' ).offset().left - jQuery(window).scrollLeft();
                jQuery( '#merge-tags-box' ).css( 'left', posX );
                jQuery( '#merge-tags-box' ).css( 'width', $this.closest( '.nf-settings' ).width() );
            }

            var dataID = jQuery( this ).data( 'id' );
            if( dataID && 'eq' != dataID ) return;

            // var offset = jQuery( view.el ).find( '.setting' ).parent().outerHeight();
            // jQuery( view.el ).find( '.setting' ).parent().append( jQuery( '#merge-tags-box' ) );
            // jQuery( '#merge-tags-box' ).css( 'top', offset );
        },

        keyupCallback: function( event, target, type ){
            var type = type || 'setting';

            // Check if this event originated from a Quill editor
            // If so, skip - rte.js handles merge tag detection for Quill via text-change event
            var $eventTarget = jQuery(event.target);
            if ($eventTarget.hasClass('ql-editor') || $eventTarget.closest('.ql-editor').length > 0) {
                return; // Let rte.js handle Quill merge tag detection
            }

            // Also skip if the setting contains a Quill editor (event bubbled up)
            var $this = jQuery(this);
            if ($this.find('.ql-editor').length > 0) {
                return; // Let rte.js handle Quill merge tag detection
            }

            if( /* ENTER */ 13 == event.keyCode ){

                // Get top listed merge tag.
                var firstFilteredTag = jQuery( '#merge-tags-box .merge-tag-list ul li span' ).first().data( 'tag' );

                nfRadio.channel( 'mergeTags' ).request( 'insert:tag', firstFilteredTag );

                // COPIED FROM BELOW
                jQuery( '#merge-tags-box' ).css( 'display', 'none' );
                nfRadio.channel( 'drawer' ).request( 'enable:close' );
                jQuery( '#merge-tags-box' ).removeClass();
                jQuery( '.merge-tag-focus' ).removeClass( 'merge-tag-focus' );
                jQuery( '.merge-tag-focus-overlay' ).removeClass( 'merge-tag-focus-overlay' );

                return;
            }

            if( 'undefined' != typeof target ) {
                $this = jQuery(target);
            }

            // TODO: Disable Browser Autocomplete
            // $this.attr()


            var dataID = jQuery( this ).data( 'id' );
            if( dataID && 'eq' == dataID ) return;

            // Store the current caret position.
            if( 'rte' == type ){
                var caretPos = 0;
                if( window.nfCurrentCodeMirror ) {
                    caretPos = window.nfCurrentCodeMirror.indexFromPos(window.nfCurrentCodeMirror.getCursor());
                } else if( window.nfCurrentQuillInstance ) {
                    var range = window.nfCurrentQuillInstance.getSelection();
                    caretPos = range ? range.index : 0;
                }
            } else {
                var caretPos = $this.caret();
            }
            nfRadio.channel( 'mergeTags' ).request( 'set:caret', caretPos );

            // Find merge tags.
            if( 'rte' == type ) {
                var content = '';
                if ( window.nfCurrentCodeMirror ) {
                    content = window.nfCurrentCodeMirror.getValue();
                } else if ( window.nfCurrentQuillInstance ) {
                    content = window.nfCurrentQuillInstance.root.innerHTML;
                }
                var mergetags = content.match(new RegExp(/{([a-zA-Z0-9]|:|_|-|}| |\/)*/g));
            } else {
                var mergetags = $this.val().match(new RegExp(/{([a-zA-Z0-9]|:|_|-|}| |\/)*/g));
            }

            // Filter out closed merge tags.
            mergetags = _.filter(mergetags, function(mergetag) {
                return -1 == mergetag.indexOf( '}' ); // Filter out "closed" merge tags.
            });

            // If an open merge tag is found, show the Merge Tag Box, else hide.
            if( 0 !== mergetags.length ) {

                nfRadio.channel( 'mergeTags' ).request( 'set:old', mergetags[0] );
                
                jQuery('#merge-tags-box').css( 'display', 'block' );
                nfRadio.channel( 'drawer' ).request( 'prevent:close' );
                $this.addClass('merge-tag-focus');

                var boxHeight = jQuery( '#merge-tags-box' ).outerHeight();
                jQuery( '#nf-drawer' ).css( 'padding-bottom', boxHeight + 'px' );

                // Disable browser autocomplete.
                var autocomplete = $this.attr( 'autocomplete' );
                $this.attr( 'autocomplete', 'off' );
                $this.data( 'autocomplete', autocomplete );

                var $overlayElement = $this.closest( '.nf-setting, .nf-table-row' );
                if( 0 != $overlayElement.find( '.ql-container' ).length ){
                    $overlayElement.find('.ql-container' ).parent().addClass('merge-tag-focus-overlay');
                } else {
                    $overlayElement.addClass('merge-tag-focus-overlay');
                }

                $overlayElement.off( 'click' );
                $overlayElement.on( 'click', function( event ){
                    var elementClasses = jQuery( event.target ).attr( 'class' ) || [];
                    if( -1 !== elementClasses.indexOf( 'merge-tag-focus-overlay' ) ){
                        nfRadio.channel( 'mergeTags' ).request( 'insert:tag', '' );
                        jQuery( '#merge-tags-box' ).css( 'display', 'none' );
                        nfRadio.channel( 'drawer' ).request( 'enable:close' );
                        jQuery( '#merge-tags-box' ).removeClass();
                        jQuery( '.merge-tag-focus' ).removeClass( 'merge-tag-focus' );
                        jQuery( '.merge-tag-focus-overlay' ).removeClass( 'merge-tag-focus-overlay' );
                    }
                });

                var value = mergetags[0].replace( '{', '' );
            } else {
                jQuery( '#merge-tags-box' ).css( 'display', 'none' );
                nfRadio.channel( 'drawer' ).request( 'enable:close' );
                jQuery( '#merge-tags-box' ).removeClass();
                jQuery( '.merge-tag-focus' ).removeClass( 'merge-tag-focus' );
                jQuery( '.merge-tag-focus-overlay' ).removeClass( 'merge-tag-focus-overlay' );
            }
        }

    } );

    return controller;
} );

